<template>
  <form @submit.prevent="emitSearchEvent">
    <base-input v-model="searchText"
                :placeholder="$t('tvChannels.searchPlaceholder')"
                v-bind="[$attrs, $props]"
                @keyup.native.esc="clearSearch"
                class="search-input">
      <base-button slot="input-button"
                   variant="text"
                   class="icon-search"
                   @click="emitSearchEvent"/>
    </base-input>
  </form>
</template>

<script>
import BaseInput from '../base/base-input'
import BaseButton from '../base/base-button'

export default {
  name: 'channels-search-input',
  components: { BaseInput, BaseButton },
  data () {
    return {
      searchText: ''
    }
  },
  methods: {
    emitSearchEvent () {
      this.$emit('search-channels', this.searchText)
    },
    clearSearch () {
      this.searchText = ''
      this.emitSearchEvent()
    }
  }
}
</script>

<style scoped>
.search-input {
  width: 100%;
}
</style>
